// Firebase Cloud Messaging configuration
// Store sensitive credentials here instead of hardcoding in components

const DEPLOY_ENV = process.env.DEPLOY_ENV || 'development'

export const FCM_CONFIG = {
  // VAPID Key for Firebase Messaging
  // Move to .env file in production
  VAPID_KEY: process.env.VUE_APP_FCM_VAPID_KEY,

  // Firebase server key for topic subscription
  // Move to backend service (never expose in frontend)
  // TODO(security): this legacy FCM server key is still bundled into the
  // frontend (used by Dashboard.subscribeFcm -> iid.googleapis.com). It grants
  // send access to the whole Firebase project and is already exposed in the
  // shipped bundle + git history. Move topic subscription to the backend
  // (frontend should only POST its FCM token to our API), keep this key as a
  // server-side secret, and rotate it. Prefer the FCM HTTP v1 API over the
  // deprecated legacy server key / iid.googleapis.com endpoint.
  SERVER_KEY: process.env.VUE_APP_FCM_SERVER_KEY,

  // FCM topic prefix
  TOPIC_PREFIX: 'ADMIN_ROLE_ID',

  // Deployment environment
  DEPLOY_ENV
}

export const STORAGE_KEYS = {
  PROJECT_ID: 'projectId',
  PROJECT_NAME: 'projectName',
  ADMIN_ROLE_PERMISSION: 'adminRolePermission'
}

// Build FCM topic from roleId and environment
export function buildFcmTopic(roleId) {
  let topic = `${FCM_CONFIG.TOPIC_PREFIX}-${roleId}`
  if (FCM_CONFIG.DEPLOY_ENV !== 'production') {
    topic = [FCM_CONFIG.DEPLOY_ENV, topic].join('~')
  }
  return topic
}
